/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
import { canUseDOM, chaseCodes, amexCodes } from '@marriott/mi-ui-library';
import { selectorList } from '../../constants/constants';
import { targetPayloadRequest, useSession } from '@marriott/mi-headless-utils';
import { RefObject, useRef } from 'react';
import { FeatureIcon, FeatureIconColor, iconColorMap } from './enums';
import { useEffect, useState } from 'react';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { isEmpty } from '@marriott/shared/mi-helper-utils';
import { useRouter } from 'next/router';

declare global {
  interface Window {
    _satellite: Record<string, any>;
    adobeDataLayer: {
      [key: number]: {
        event: string;
        [key: string]: { [key: string]: unknown } | string | undefined | boolean;
      };
      version: number;
      push: (event: {
        event: string;
        [key: string]: { [key: string]: unknown } | string | undefined | boolean;
      }) => void;
      getState: () => Record<string, unknown>;
      addEventListener: (type: string, listener: EventListenerOrEventListenerObject) => void;
      removeEventListener: (type: string, listener: EventListenerOrEventListenerObject) => void;
    };
  }
}

//Method to return column class helper for various components
export const getColumnClass = (columnLayout: string, tabType: string) => {
  let customClass = '';
  if (columnLayout === '1-column') {
    customClass = 'col-12 ';
  } else if (columnLayout === '3-column') {
    if (tabType === 'personal') {
      customClass = 'col-6 col-md-4';
    } else {
      customClass = 'col-12 col-md-4';
    }
  } else {
    customClass = 'col-6';
  }
  return customClass;
};

export function getDataLayerScript(dataLayer: { data: any; mvpOffersData: string }) {
  return `var dataLayer = ${dataLayer?.data ? JSON.stringify(dataLayer?.data[0]) : '{}'}; var mvpOffers = ${
    dataLayer?.mvpOffersData && dataLayer?.mvpOffersData !== 'null' ? dataLayer?.mvpOffersData : '{}'
  };`;
}

//Method to remove extra spacing in on resize
export const removeExtraHeights = (ref: RefObject<HTMLDivElement>) => {
  if (canUseDOM) {
    selectorList?.map(({ selector, rowCount }) => {
      for (let row = 1; row <= rowCount; row++) {
        const requiredElem = ref?.current?.querySelectorAll(`.${selector}-${row}`);
        if (requiredElem && requiredElem.length) {
          requiredElem.forEach((node: any) => {
            if (node && node.style) {
              node.style.minHeight = '';
            }
          });
        }
      }
    });
  }
};

//Method to equalize height of points section elements
const equalizeCardHeight = (selector: string, rowCount: number, ref: RefObject<HTMLDivElement>) => {
  if (canUseDOM) {
    for (let row = 1; row <= rowCount; row++) {
      const allNodes = ref?.current?.querySelectorAll(`.${selector}-${row}`);
      let maxHeight = 0;
      if (allNodes && allNodes.length) {
        allNodes.forEach(node => {
          if (node.clientHeight > maxHeight) {
            maxHeight = node.clientHeight;
          }
        });
        allNodes.forEach((node: any) => {
          if (node && node.style) {
            node.style.minHeight = maxHeight + 'px';
          }
        });
      }
    }
  }
};

export const equalizeBankLandingCards = (ref: RefObject<HTMLDivElement>) => {
  selectorList?.map(currentElem => {
    const { selector, rowCount } = currentElem;
    equalizeCardHeight(selector, rowCount, ref);
  });
};

export const referAFriend = (dataLayer: any, ref: RefObject<HTMLDivElement>) => {
  if (
    dataLayer &&
    dataLayer['mr_prof_authentication_state'] &&
    dataLayer['mr_prof_authentication_state'] === 'authenticated'
  ) {
    const cardDetails = dataLayer['mr_prof_cc_all'];
    const detailsArray = cardDetails ? cardDetails?.toString()?.split(',') : [];
    const ccFromDom: (string | undefined)[] = [];
    const cardDetailsElements = ref?.current?.querySelectorAll('.refer-friend-link');
    if (cardDetailsElements) {
      cardDetailsElements.forEach(ele => {
        const tempEle = ele as HTMLElement;
        ccFromDom.push(tempEle.dataset?.['creditcardcode']?.trim());
      });
      const tempArray = ccFromDom.filter(code => detailsArray.includes(code as string));
      tempArray.forEach(element => {
        cardDetailsElements.forEach(ele => {
          const tempEle = ele as HTMLElement;
          const cardCodeforEle = tempEle.dataset?.['creditcardcode']?.trim();
          if (cardCodeforEle === element) {
            tempEle.classList.remove('d-none');
          }
        });
      });
    }
  }
};
export const getUserLocation = function (adobeDataLayer: unknown = undefined) {
  const dataLayer = (adobeDataLayer || global?.window?.dataLayer) as Record<string, string | unknown>;
  if (dataLayer?.['memState'] && dataLayer?.['memState'] === 'authenticated') {
    return dataLayer?.['mr_prof_address_country'];
  } else {
    return dataLayer?.['browser_akamai_loc_country'];
  }
};
export const setObserver = (componentId: any, ref: RefObject<HTMLDivElement>) => {
  const pageWcmMode = document.getElementsByTagName('html')[0];
  const updateStyleComponent = ref?.current?.querySelector(`#${componentId}__slides`);
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        const currWcmMode = pageWcmMode?.getAttribute('class');
        if (currWcmMode?.includes('Edit')) {
          updateStyleComponent?.classList.add('glide__slides_authoring');
        } else if (currWcmMode?.includes('Preview')) {
          updateStyleComponent?.classList.remove('glide__slides_authoring');
        }
      }
    });
  });
  observer.observe(pageWcmMode, { attributes: true });

  return () => {
    observer.disconnect();
  };
};

export const shouldCardDisplay = (cardType: string, activeTab: string) => {
  let displayClass = true;
  if (cardType && cardType === 'business') {
    if (activeTab && activeTab !== 'business') {
      displayClass = false;
    }
  }
  if (cardType && cardType === 'personal') {
    if (activeTab && activeTab !== 'personal') {
      displayClass = false;
    }
  }
  return displayClass;
};

// helper function to get icon color based on status
export const getIconColor = (status: FeatureIcon): FeatureIconColor => {
  return iconColorMap[status];
};

/**
 * Function to determine if the user is on a mobile device
 */
export const isMobile = (): boolean => {
  // handle server-side rendering case
  if (typeof navigator === 'undefined') {
    return false;
  }
  const isTablet = !!(/Linux/i.test(navigator.userAgent) && navigator?.maxTouchPoints > 1);
  const isIpad = !!(
    /Macintosh/i.test(navigator.userAgent) &&
    navigator?.maxTouchPoints < 6 &&
    navigator?.maxTouchPoints > 0
  );
  return (
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || isTablet || isIpad
  );
};

/**
 * Function extracts a paragraph that includes "Annual Fee" in <p></p> tag from the authored html code
 */
export const extractAnnualFee = (innerHtml: string): string | undefined => {
  if (!innerHtml) {
    return undefined;
  }

  const lower = innerHtml.toLowerCase();
  let searchFrom = 0;
  let pOpen = lower.indexOf('<p', searchFrom);

  // Loop while we can find more <p> tags
  while (pOpen !== -1) {
    const gt = lower.indexOf('>', pOpen + 2);
    if (gt === -1) return undefined;

    const pClose = lower.indexOf('</p>', gt + 1);
    if (pClose === -1) return undefined;

    const content = innerHtml.slice(gt + 1, pClose);
    // Case-insensitive includes without regex
    if (content.toLowerCase().includes('annual fee')) {
      return innerHtml.slice(pOpen, pClose + 4);
    }

    // Move to next paragraph
    searchFrom = pClose + 4;
    pOpen = lower.indexOf('<p', searchFrom);
  }

  // No paragraph with "annual fee" found
  return undefined;
};

export const setCardArray = (cardArray: any) => {
  const dataArray: any[] = [];
  for (const cardKey in cardArray) {
    if (cardKey !== 'categories') {
      const eachCardData = Object.values(cardArray[cardKey]);
      eachCardData.map((data: any) => {
        data.cardId = cardKey;
        return data;
      });
      dataArray.push(...eachCardData);
    }
  }
  return dataArray;
};

export const replaceWhitespaceAndAddBtn = (componentId: string | undefined): string => {
  if (componentId === undefined) {
    return '';
  }
  return componentId.replace(/\s+/g, '-') + '-btn';
};

export const useAlloyTargetMethod = (targetMboxValue?: string) => {
  const router = useRouter();
  const queryParams = router.query;
  const DST_VALUES = [...amexCodes, ...chaseCodes];
  const isDSTvalue = DST_VALUES.some(key =>
    Object.keys(queryParams).some(param => param.toLowerCase() === key?.toLowerCase())
  );

  const [isTargetContentLoaded, setIsTargetContentLoaded] = useState(false);
  const [targetData, setTargetData] = useState<any>('');
  const { datalayer, mvpOffers, updateDatalayer } = useSession();
  let counter = 0;
  const hasCalledFetchTargetData = useRef(false);

  useEffect(() => {
    if (!isEmpty(datalayer) && !hasCalledFetchTargetData.current) {
      hasCalledFetchTargetData.current = true;

      if (targetMboxValue && !isDSTvalue) {
        launchLoadedAddEventListener();
      } else {
        setIsTargetContentLoaded(true);
      }
    }
  }, [datalayer]);

  if (!targetMboxValue) {
    return { isTargetContentLoaded: true, targetData: '' };
  }

  const launchLoadedAddEventListener = () => {
    const handleLaunchLoaded = () => {
      if (counter < 1) {
        fetchTargetData(targetMboxValue);
        counter = counter + 1;
      }
    };

    if (window !== undefined && window.adobeDataLayer) {
      window?.adobeDataLayer?.addEventListener('launchLoaded', handleLaunchLoaded);
    }

    const timeoutId = setTimeout(() => {
      if (window !== undefined) {
        window?.adobeDataLayer?.removeEventListener('launchLoaded', handleLaunchLoaded);
        setIsTargetContentLoaded(true);
      }
    }, 10000);

    return () => {
      clearTimeout(timeoutId);
      if (window !== undefined && window.adobeDataLayer) {
        window?.adobeDataLayer?.removeEventListener('launchLoaded', handleLaunchLoaded);
      }
    };
  };

  const fetchTargetData = async (targetMboxValue?: string) => {
    const targetMbox = targetMboxValue && [targetMboxValue];
    const payLoad = targetPayloadRequest(
      {
        isUxl: 'false',
        locale:
          window?.sessionData?.locale?.replace('-', '_') ||
          window?._satellite?.['getVar']('brwsrLang') ||
          datalayer?.['brwsrLang'] ||
          'en_US',
        mboxName: targetMbox,
        propertyToken: useClientEnvVarsStore.getState().envVarsObject['TARGET_PROPERTY_TOKEN'],
      },
      datalayer,
      mvpOffers
    );
    try {
      const result = await window?.alloy<any>('sendEvent', {
        data: {
          __adobe: {
            target: payLoad?.execute?.mboxes?.[0]?.parameters,
          },
        },
        xdm: {},
        decisionScopes: targetMbox,
      });

      const propositions = result?.propositions;
      let item: any;
      let experience: any;
      let foundProposition = false;

      if (propositions && targetMboxValue) {
        for (const proposition of propositions) {
          item = proposition?.scope;
          if (item === targetMboxValue) {
            console.log(
              'PROPOSITION SELECTED',
              proposition?.items[0].data.content[':items'].root[':items'].responsivegrid[':items']
            );
            console.log('Experience name', proposition?.items[0].meta['experience.name']);
            experience = proposition?.items[0].meta['experience.name'];
            setTargetData(proposition?.items[0].data.content[':items'].root[':items'].responsivegrid[':items']);
            foundProposition = true;
          }
        }

        setIsTargetContentLoaded(true);

        if (foundProposition) {
          updateDatalayer({
            event: 'card-layout-updated',
            data: { item, experience },
            skipDatalayerUpdate: true,
          } as any);
        }
      }

      if (item) {
        window?.alloy('sendEvent', {
          xdm: {
            eventType: 'decisioning.propositionDisplay',
            _experience: {
              decisioning: {
                propositions: [
                  {
                    id: item?.id,
                    scope: item?.scope,
                    scopeDetails: item?.scopeDetails,
                  },
                ],
                propositionEventType: {
                  display: 1,
                },
              },
            },
          },
        });
      }
    } catch (error) {
      console.log('Error occurred in Target call', error);
      setIsTargetContentLoaded(true);
    }
  };

  return { isTargetContentLoaded, targetData: targetData };
};
